<template>
  <div>
    <!-- Booking Failed Message -->
    <div class="container">
      <div class="px-3" style="margin-bottom: 50px">
        <div class="style-header scss-bold">Booking Failed!</div>

        <div class="mt-5 text-center scss-small-font">
          Ops! There is some problem encoutered while making the booking. Kindly
          try again or contact the shop if problem persist.
        </div>
      </div>
    </div>

    <!-- Homepage Button -->
    <div class="scss-button-position-bottom">
      <default-button title="Home" @click="goToHomePage" />
    </div>
  </div>
</template>

<script>
import DefaultButton from "@/components/button/DefaultButton.vue";

export default {
  name: "BookingFailed",
  components: { DefaultButton },
  data() {
    return {};
  },
  methods: {
    goToHomePage() {
      this.$router.push("/home");
    },
  },
  created() {
    sessionStorage.removeItem("timeslot");
    sessionStorage.removeItem("serviceDetails");
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-header {
  color: red;
  font-size: 18px;
}
</style>
